import { useProfilesManaged } from "@lens-protocol/react-web";
import { useAccount as useWagmiAccount } from "wagmi";

interface Props {
  farcasterError?: string;
}

export function LoginPageImage({ farcasterError }: Props) {
  const { address } = useWagmiAccount();
  if (farcasterError) {
    return <ErrorImage />;
  }

  if (address) {
    return <Web3ConnectedImage owner={address} />;
  }

  return <DefaultImage />;
}

function Web3ConnectedImage({ owner }: { owner: string }) {
  const {
    data: profiles,
    error,
    loading,
  } = useProfilesManaged({
    for: owner,
    includeOwned: true,
  });

  const isError = error || (!loading && profiles?.length === 0);

  if (isError) {
    return <ErrorImage />;
  }

  return <DefaultImage />;
}

function DefaultImage() {
  return (
    <img
      src="/assets/home-illustration.png"
      alt="home illustration"
      className="w-[120px]"
    />
  );
}

function ErrorImage() {
  return (
    <img
      src="/assets/home-error-illustration.png"
      alt="home illustration"
      className="w-[120px]"
    />
  );
}
